import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Category } from "../category";
import { Organization } from "../organization";
import { Team } from "../team";
import { AidRequestFormEntityConfig } from "./config";
import { AidRequestFormFilters } from "./filters";
import { AidRequestFormMethods } from "./methods";

@HyperEntity("aid-request-form", AidRequestFormEntityConfig)
export class AidRequestForm extends extender(
  AidRequestFormFilters,
  AidRequestFormMethods,
) {
  @Fields.id()
  id = "";

  @Relations.toMany(() => Category, "aidRequestForm")
  categories: Category[] = [];

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne<AidRequestForm, Organization>(
    () => Organization,
    "organizationId",
  )
  organization?: Organization;

  @Fields.string({ dbName: "team_id" })
  teamId = "";

  @Relations.toOne<AidRequestForm, Team>(() => Team, "teamId")
  team?: Team;

  @Fields.string()
  title = "";

  @Fields.string({ dbName: "image_id" })
  imageId = "";

  @Fields.boolean({ dbName: "has_time" })
  hasTime = false;

  @Fields.string()
  description = "";

  @Fields.string()
  notes = "";

  @Fields.updatedAt({
    dbName: "created_at",
  })
  createdAt: Date = new Date();

  @Fields.createdAt({
    dbName: "updated_at",
  })
  updatedAt: Date = new Date();
}
